<template>
  <div class="content">
    <div class="body-2 content-field"
      v-html="content"
    />
    <tooltip  v-if="tooltip" :text="tooltip" />
    <helpIcon v-if="helpContent" :content="helpContent" />
  </div>
</template>

<script>
/**
 * @fileoverview Config field for content
 *
 * @author Dan Kenemer <dan.kenemer@quavo.com>
 */
import helpIcon from "@/components/help-icon";
import tooltip from "@/components/tooltip";

export default {
  name: "ContentField",
  components: {
    tooltip,
    helpIcon
  },
  props: {
    category: {
      type: String,
    },
    id: {
      type: String,
    },
    content: {
      type: String,
    },
    helpContent: {
      type: String,
    },
    tooltip: {
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: $qvo-spacing-8;
}

</style>